module.exports = __webpack_public_path__ + "media/images/850/healthy-94f358a38b5746d26409b915e7a71a3f.jpg";